/* eslint-disable import/prefer-default-export */
import * as React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { PropertySelectState } from '../../../../Types';

interface PropertySelectStateTextProps {
    count: number;
    state: PropertySelectState;
}

export const PropertySelectStateText: React.FC<PropertySelectStateTextProps> = ({ count, state }) => {
    const { t } = useTranslation(['forms']);

    if (state === PropertySelectState.ALL) {
        return <p>{t('forms:selectors.tenants.allTenantsSelected')}</p>;
    }

    return (
        <p>
            <Trans i18nKey="forms:selectors.tenants.tenantsSelectedCount" count={count} />
        </p>
    );
};
